<script>
import Layout from '@layouts/primary'
import { runsheetMethods, vehicleMethods, collectionMethods } from '@state/helpers'
import ListLoading from '../../components/loading'
import RunSheetReassignModal from '@/src/components/run-sheet-reassign-modal.vue'
export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'RunSheets',
    meta: [{ name: 'description', content: 'RunSheets' }],
  },
  components: { Layout, ListLoading, RunSheetReassignModal },
  data() {
    return {
      search: '',
      loadingData: true,
      error: false,
      errorText: '',
      headers: [
        { text: 'Run No.', value: 'id' },
        { text: 'Route', value: 'route' },
        { text: 'Truck Rego', value: 'vehicle.number_plate' },
        { text: 'Date', value: 'dateSeconds' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'name', sortable: false, align: 'end' },
      ],
      searchInput: "",
      dateDialog: false,
      runSheetDateDialog: false,
      vehicles: [],
      vehiclePlates: [],
      vehicleIds: [],
      runSheets: [],
      newRunSheet: {
        vehicle_id: null,
        date: null,
      },
      upcomingRunSheets: {
        date: null,
      },
      formError: null,
      dictionary: {
        attributes: {
          // email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
        },
      },
      addRunSheet: false,
      generateRunSheet: false,
      reassignRunsheet: null
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    let moment = require('moment')
    let date = moment().format('YYYY-MM-DD')
    this.getVehicles().then(res => {
      this.getUpcomingRunsheets({ date: date }).then(response => {
        let allVehicles = this.$store.state.vehicles.objects
        for (const vehicle in allVehicles) {
          // console.log(vehicle)
          this.vehiclePlates.push(allVehicles[vehicle].number_plate)
          this.vehicles.push(allVehicles[vehicle])
        }
        // this.vehicles = allVehicles.map(vehicle=>vehicle.number_plate)
        let obj = this.$store.state.runsheets.runsheetsUpcoming
        // console.log(allVehicles)
        for (let v in obj) {
          // Create a copy of the obj to be able to change its info
          let formattedRun = {
            ...obj[v],
          }

          let currentDate = moment(formattedRun.date).format('YYYY-MM-DD')
          formattedRun.date = moment(formattedRun.date).format('DD/MM/YYYY')
          formattedRun.dateSeconds = moment(currentDate).valueOf()
          let collections = obj[v].collections

          // Default status as completed, will change in the code below if not
          formattedRun.status = 'Completed'

          if (collections.length === 0) {
            formattedRun.route = 'Empty Run'
            formattedRun.status = 'Empty Run'
          } else {
            // console.log(collections)
            if(collections.length > 0){
              formattedRun.route = obj[v].route.name
              if (!collections[0].completed) {
                formattedRun.status = 'In Progress'
              }
            }

          }

          for (let index in collections) {
            if (!collections[index].completed) {
              formattedRun.status = 'In Progress'
            }
          }

          if (currentDate !== date) {
            formattedRun.status = 'Upcoming'
          }
          this.runSheets.push(formattedRun)
        }
        // console.log(this.runSheets)
        this.loadingData=false
        // eslint-disable-next-line handle-callback-err
      }).catch(error => {
        this.loadingData=false
      })
    })

  },
  methods: {
    ...vehicleMethods,
    ...runsheetMethods,
    ...collectionMethods,
    async submit() {
      await this.$validator.validateAll().then(response => {
        // console.log(response)
        if (response) {
          const vehicleId = this.findVehicleByPlate(
            this.newRunSheet.vehicle_id
          ).id
          this.createRunsheet({
            vehicle_id: vehicleId,
            date: this.newRunSheet.date,
          })
            .then(d => {
              location.reload()
            })
            .catch(err => {
              this.addRunSheet = false
              this.errorText = JSON.stringify(err)
              this.error = true
            })
        }
      })
    },
    async generateUpcomingRunsheet() {
      // Reset the formError if it existed.
      this.formError = null
      if (this.upcomingRunSheets.date === null) {
        this.formError = true
      } else {
        this.loadingData = true
        this.generateSchedule({
          date: this.upcomingRunSheets.date,
        })
          .then(d => {
            this.loadingData = false
            location.reload()
          })
          .catch(err => {
            this.loadingData = false
            this.generateRunSheet = false
            this.errorText =
              'There are no collections scheduled to be picked up on this date'
            this.error = true
            console.error(err)
          })
      }
    },
    clear() {
      this.$validator.reset()
      this.addRunSheet = false
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    onDateChange(date) {
      this.dateDialog = false
      this.runSheetDateDialog = false
    },
    findVehicleByPlate(plate) {
      let result = this.vehicles.find(obj => obj.number_plate === plate)
      return result
    },
    onClickReassign(runsheet) {
      this.reassignRunsheet = runsheet
    },
    async onSubmitReassign(targetRunsheetIds) {
      this.loadingData = true
      const collectionIds = this.reassignRunsheet.collections.map(item => parseInt(item.id))
      
      this.reassignRunsheet = null
      
      const result = {};
      const totalTargets = targetRunsheetIds.length;
      const baseChunkSize = Math.floor(collectionIds.length / totalTargets);
      let remainder = collectionIds.length % totalTargets;

      let index = 0;

      for (const target of targetRunsheetIds) {
        const extra = remainder > 0 ? 1 : 0;
        const chunkSize = baseChunkSize + extra;

        result[target] = collectionIds.slice(index, index + chunkSize);
        index += chunkSize;

        remainder -= extra;
      }

      
      for (const runsheetId in result) {
        await this.moveCollectionsToRunSheet({
          collectionIds: result[runsheetId],
          runsheetId
        })
      }

      this.loadingData = false
      location.reload()
    }
  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <div class>
        <h2 :class="$style.routeHeader">
          Run Sheets
        </h2>
        <ListLoading :display="loadingData" />
        <VBtn
          v-if="!loadingData"
          slot="activator"
          :class="$style.addButton"
          color="blue"
          @click="addRunSheet = !addRunSheet"
        >+ ADD RUN SHEET</VBtn>
        <VBtn
          v-if="!loadingData"
          slot="activator"
          color="green"
          :class="$style.addButton"
          @click="generateRunSheet = !generateRunSheet"
        >GENERATE UPCOMING RUN SHEETS</VBtn>
      </div>

      <VLayout style="width: 100%">
        <VFlex
          xs0
          sm12
        />
        <VFlex
          xs12
          md5
        >
          <VTextField
            v-if="!loadingData"
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </VFlex>
      </VLayout>

      <VDataTable
        v-if="!loadingData"
        :headers="headers"
        :items="runSheets"
        :search="search"
        rows-per-page-text
        :rows-per-page-items="[10]"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td class="text-xs-left">
            {{ props.item.id }}
          </td>
          <td class="text-xs-left">
            {{ props.item.route }}
          </td>
          <td class="text-xs-left">
            {{ props.item.vehicle.number_plate }}
          </td>
          <td class="text-xs-left">
            {{ props.item.date }}
          </td>
          <td class="text-xs-left">
            {{ props.item.status }}
          </td>
          <td class="justify-center layout px-0">
            <VBtn
              slot="activator"
              color="blue"
              :disabled="reassignRunsheet != null"
              @click.native="changeRoute({name: 'view-runsheet', params: {id: props.item.id, collections: props.item.collections}})"
            >View</VBtn>

            <VBtn
              slot="activator"
              color="orange"
              :disabled="reassignRunsheet != null"
              @click.native="onClickReassign(props.item)"
            >Reassign All</VBtn>
          </td>
        </template>
      </VDataTable>
    </VContainer>

    <RunSheetReassignModal 
      :visible="reassignRunsheet != null" 
      :runsheet="reassignRunsheet" 
      @submit="onSubmitReassign" 
      @close="reassignRunsheet = null"
    />

    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="addRunSheet"
        persistent
        max-width="300px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Add Runsheet</h2>
              <VLayout
                wrap
                row
              >
                <VFlex xs11>
                  <VAutocomplete
                    v-model="newRunSheet.vehicle_id"
                    v-validate="'required'"
                    :error-messages="errors.collect('vehicle')"
                    data-vv-name="vehicle"
                    :items="vehiclePlates"
                    item-text="id"
                    label="Vehicle"
                    required
                    :menu-props="{ absolute: true }"
                    :search-input.sync="searchInput"
                    attach
                  />
                </VFlex>

                <VFlex xs12>
                  <VDialog
                    v-model="dateDialog"
                    persistent
                    width="290px"
                  >
                    <VTextField
                      slot="activator"
                      v-model="newRunSheet.date"
                      v-validate="'required'"
                      :error-messages="errors.collect('runsheet_date')"
                      data-vv-name="runsheet_date"
                      label="Date"
                      append-icon="event"
                      readonly
                    />
                    <VDatePicker
                      v-model="newRunSheet.date"
                      header-color="#00baff"
                      color="#00baff"
                      scrollable
                      @input="onDateChange(newRunSheet.date)"
                    />
                  </VDialog>
                </VFlex>
              </VLayout>
              <VLayout
                wrap
                row
              >
                <VFlex
                  xs12
                  sm12
                  md12
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="submit()"
                  >
                    Save
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm12
                  md12
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="clear()"
                  >
                    Close
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>

    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="generateRunSheet"
        persistent
        max-width="300px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Generate Runsheet</h2>
              <VLayout
                wrap
                row
              >
                <VFlex xs12>
                  <VDialog
                    v-model="runSheetDateDialog"
                    persistent
                    width="290px"
                  >
                    <VTextField
                      slot="activator"
                      v-model="upcomingRunSheets.date"
                      data-vv-name="upcoming_runsheet"
                      label="Date"
                      append-icon="event"
                      required
                      readonly
                    />
                    <VDatePicker
                      v-model="upcomingRunSheets.date"
                      header-color="#00baff"
                      color="#00baff"
                      scrollable
                      @input="onDateChange(upcomingRunSheets.date)"
                    />
                  </VDialog>
                  <p
                    v-if="formError"
                    :class="$style.error"
                  >
                    Date cannot be empty
                  </p>
                </VFlex>
              </VLayout>
              <VLayout
                wrap
                row
              >
                <VFlex
                  xs12
                  sm12
                  md12
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="generateUpcomingRunsheet()"
                  >
                    Generate
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm12
                  md12
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="generateRunSheet = !generateRunSheet"
                  >Close</VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>
    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="error"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2 style="color:#cc0000;text-align:center;">
                Error
              </h2>
              <VFlex
                style="text-align:center;"
                xs12
              >
                {{ errorText }}
              </VFlex>
              <VLayout wrap>
                <VFlex
                  xs12
                  sm12
                  md12
                >
                  <VBtn
                    style="border-color:#cc0000 !important"
                    color="#cc0000"
                    block
                    outline
                    @click.native="error = !error"
                  >Close</VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.routeHeader {
  display: inline-block;
}

.addButton {
  display: inline-block;
  float: right;
}
</style>
